export default __webpack_public_path__ + "ef1b4f3.png";